/**
 * Hiyaku Product Main Logic
 * グローバルにイベントを監視し、動的に追加されたセクション（クイックビュー等）にも対応
 * theme.liquid で読み込むため、Ajax で後から注入された HTML 内の操作にも反応する
 */
(function() {
  function formatMoney(cents) {
    return '¥' + Math.round(cents / 100).toLocaleString();
  }

  function showImage(section, index) {
    var galleryImages = section.querySelectorAll('.univ-product-main__gallery-image');
    var thumbnails = section.querySelectorAll('[data-thumbnail-index]');
    if (index < 0 || index >= galleryImages.length) return;
    galleryImages.forEach(function(img, i) {
      if (i === index) {
        img.classList.add('is-active');
        img.classList.remove('is-hidden');
      } else {
        img.classList.remove('is-active');
        img.classList.add('is-hidden');
      }
    });
    thumbnails.forEach(function(thumb, i) {
      if (i === index) {
        thumb.classList.add('is-active');
      } else {
        thumb.classList.remove('is-active');
      }
    });
  }

  function updateVariant(section, productJson) {
    var form = section.querySelector('[data-product-form]');
    var variantIdInput = form ? form.querySelector('[data-variant-id]') : null;
    var priceEl = section.querySelector('[data-product-price]');
    var comparePriceEl = section.querySelector('[data-compare-price]');
    var discountEl = section.querySelector('[data-discount-percent]');
    var addToCartBtn = section.querySelector('[data-add-to-cart]');
    var buyNowBtn = section.querySelector('[data-buy-now]');
    var galleryImages = section.querySelectorAll('.univ-product-main__gallery-image');

    var selectedOptions = [];
    section.querySelectorAll('[data-option-index]').forEach(function(group, index) {
      var checked = group.querySelector('input:checked');
      if (checked) {
        selectedOptions[index] = checked.value;
        var selectedLabel = group.querySelector('[data-selected-option]');
        if (selectedLabel) selectedLabel.textContent = checked.value;
      }
    });

    var variant = productJson.variants.find(function(v) {
      return v.option1 === selectedOptions[0] &&
             (selectedOptions[1] === undefined || v.option2 === selectedOptions[1]) &&
             (selectedOptions[2] === undefined || v.option3 === selectedOptions[2]);
    });

    if (variant) {
      if (variantIdInput) variantIdInput.value = variant.id;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());

      if (priceEl) {
        priceEl.textContent = formatMoney(variant.price);
        priceEl.classList.toggle('univ-product-main__price--sale', variant.compare_at_price > variant.price);
      }
      if (comparePriceEl) {
        if (variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = formatMoney(variant.compare_at_price);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }
      if (discountEl) {
        if (variant.compare_at_price > variant.price) {
          var discount = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
          discountEl.textContent = '-' + discount + '%';
          discountEl.style.display = '';
        } else {
          discountEl.style.display = 'none';
        }
      }
      if (addToCartBtn) {
        addToCartBtn.disabled = !variant.available;
        addToCartBtn.textContent = variant.available
          ? (addToCartBtn.dataset.addText || 'カートに追加')
          : (addToCartBtn.dataset.soldoutText || '売り切れ');
      }
      if (buyNowBtn) buyNowBtn.disabled = !variant.available;

      var targetId = (variant.featured_media && variant.featured_media.id) || (variant.featured_image && variant.featured_image.id);
      console.log('[Hiyaku Product] updateVariant: 画像切り替え処理', { variantId: variant.id, targetId: targetId, mediaCount: productJson.media ? productJson.media.length : 0, galleryCount: galleryImages.length });
      if (targetId != null && productJson.media && productJson.media.length > 0) {
        var targetIndex = productJson.media.findIndex(function(m) {
          return String(m.id) === String(targetId);
        });
        console.log('[Hiyaku Product] productJson.media 検索結果', { targetIndex: targetIndex });
        if (targetIndex === -1 && galleryImages.length > 0) {
          targetIndex = Array.from(galleryImages).findIndex(function(img) {
            var imgId = img.dataset.mediaId || img.getAttribute('data-media-id');
            return String(imgId || '') === String(targetId);
          });
          console.log('[Hiyaku Product] DOM data-media-id 検索結果', { targetIndex: targetIndex });
        }
        if (targetIndex >= 0) {
          console.log('[Hiyaku Product] showImage を呼び出します', { targetIndex: targetIndex });
          showImage(section, targetIndex);
        } else {
          console.warn('[Hiyaku Product] 画像が見つかりませんでした', { targetId: targetId });
        }
      } else {
        console.warn('[Hiyaku Product] 画像IDまたはメディア配列がありません', { targetId: targetId, hasMedia: !!productJson.media });
      }
    }
  }

  document.addEventListener('change', function(e) {
    if (!e.target || !e.target.matches) return;
    var isVariantInput = e.target.matches('input[data-option-value]') || e.target.matches('.univ-product-main__variant-option input');
    if (!isVariantInput) return;
    console.log('[Hiyaku Product] change イベント検出', { target: e.target, hasDataOptionValue: e.target.hasAttribute('data-option-value'), className: e.target.className });
    var section = e.target.closest('.univ-product-main');
    if (!section) {
      console.warn('[Hiyaku Product] .univ-product-main が見つかりません', { target: e.target });
      return;
    }
    var jsonEl = section.querySelector('[data-product-json]');
    if (!jsonEl) {
      console.warn('[Hiyaku Product] [data-product-json] が見つかりません', { section: section });
      return;
    }
    console.log('[Hiyaku Product] updateVariant を呼び出します', { section: section, inputValue: e.target.value });
    try {
      var productJson = JSON.parse(jsonEl.textContent);
      updateVariant(section, productJson);
    } catch (err) {
      console.error('[Hiyaku Product] JSON解析エラー:', err);
    }
  }, true);

  document.addEventListener('click', function(e) {
    var thumb = e.target.closest('[data-thumbnail-index]');
    if (thumb) {
      var section = thumb.closest('.univ-product-main');
      var index = parseInt(thumb.getAttribute('data-thumbnail-index'), 10);
      if (section && !isNaN(index)) showImage(section, index);
      return;
    }
    if (e.target.closest('[data-qty-minus]')) {
      var section = e.target.closest('.univ-product-main');
      var input = section ? section.querySelector('[data-qty-input]') : null;
      if (input) {
        var val = parseInt(input.value, 10) || 1;
        if (val > 1) input.value = val - 1;
      }
      return;
    }
    if (e.target.closest('[data-qty-plus]')) {
      var section = e.target.closest('.univ-product-main');
      var input = section ? section.querySelector('[data-qty-input]') : null;
      if (input) {
        var val = parseInt(input.value, 10) || 1;
        var max = parseInt(input.getAttribute('max'), 10) || 99;
        if (val < max) input.value = val + 1;
      }
      return;
    }
    if (e.target.closest('[data-buy-now]')) {
      var section = e.target.closest('.univ-product-main');
      if (!section) return;
      var form = section.querySelector('[data-product-form]');
      var cartAddUrl = section.dataset && section.dataset.cartAddUrl ? section.dataset.cartAddUrl + '.js' : '/cart/add.js';
      if (!form || !cartAddUrl) return;
      e.preventDefault();
      e.stopPropagation();
      var formData = new FormData(form);
      fetch(cartAddUrl, { method: 'POST', body: formData })
        .then(function(res) { return res.json().then(function(data) { return { ok: res.ok, data: data }; }); })
        .then(function(result) {
          if (result.ok) {
            window.location.href = '/checkout';
          } else {
            throw new Error(result.data.description || 'Error adding to cart');
          }
        })
        .catch(function(err) {
          console.error('[Hiyaku Product] Buy now error:', err);
          alert('購入に失敗しました。もう一度お試しください。');
        });
      return;
    }
    var buyNowBtn = e.target.closest('button[name="buy-now"], button[data-buy-now], .buy-now-button');
    if (buyNowBtn && buyNowBtn.closest('[data-quickview-content]')) {
      var form = buyNowBtn.closest('form[data-type="add-to-cart-form"]') || buyNowBtn.closest('form');
      if (!form) return;
      e.preventDefault();
      e.stopPropagation();
      var formData = new FormData(form);
      var variantId = formData.get('id') || (form.querySelector('input[name="id"]') && form.querySelector('input[name="id"]').value);
      if (!variantId) {
        alert('バリエーションを選択してください。');
        return;
      }
      var quantity = parseInt(formData.get('quantity') || '1', 10) || 1;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: quantity }] }) })
        .then(function(res) { return res.json().then(function(data) { return { ok: res.ok, data: data }; }); })
        .then(function(result) {
          if (result.ok) {
            window.location.href = '/checkout';
          } else {
            throw new Error(result.data.description || 'Error adding to cart');
          }
        })
        .catch(function(err) {
          console.error('[Hiyaku Product] Buy now error:', err);
          alert('購入に失敗しました。もう一度お試しください。');
        });
      return;
    }
  });

})();
